import { placeData } from "./place-data";
import { TRANSACTIONS_FR_FR } from "./transactions";
import { settings } from "./settings";
import { products } from "./products";
import { delivery } from "./delivery";
import { emissionErrors } from "./emission-errors";
import { CATERING_FR_FR } from "#pages/place/catering/translations/catering-fr-fr";

export const placeFR = {
	placeData,
	transactions: TRANSACTIONS_FR_FR,
	catering: CATERING_FR_FR,
	settings,
	products,
	delivery,
	emissionErrors,
	managerOrders: {
		orderDetailModal: {
			title: "Détails de la commande",
			orderNumber: "Commande n° #{{orderNumber}}",
			nameLabel: "Nom",
			dateLabel: "Date et heure",
			dateValue: "{{date}} à {{hour}}",
			originLabel: "Origine de la commande",
			refuseOrder: "Refuser la commande",
			acceptOrder: "Accepter la commande",
			cancelOrder: "Annuler la commande",
			dispatchOrder: "Expédier la commande",
			concludeOrder: "Conclure la commande",
			itemsTitle: "Articles de la commande",
			totalLabel: "Total de la commande",
			deliveryFeeLabel: "Frais de livraison",
			discountLabel: "Remise",
			obsLabel: "Observation",
			obsTitle: "Observations supplémentaires",
			deliveryDetailsTitle: "Détails de livraison",
			paymentMethodLabel: "Méthode de paiement",
			addressLabel: "Adresse",
			contactLabel: "Contact",
			cpfLabel: "CPF",
			phoneLabel: "Téléphone",
			unknownLabel: "Document inconnu",
			unknown: "Non renseigné",
		},
		refuseOrderConfirmation: {
			title: "Attention",
			message: "Êtes-vous sûr de vouloir refuser la commande ?",
			secondaryMessage: "Après avoir refusé la commande, le client sera notifié.",
			confirmButton: "Refuser la commande",
		},
	},
};
